var Interface = require('../core');
var _ = require('lodash');

Interface.preprocessor('key-value-pair', {
  convertToSource: function convertBackToArray(sync) {
    return _.map(sync, function (value, key) {
      return {
        value: value,
        key: key
      };
    });
  },

  /**
   * [ { key:'prop', value:'val' }, ... ] => { prop:val }
   */
  convertToSync: function (source) {
    var sourceProperties = {};

    _.each(
      source,
      function (o) {
        this[o.key] = o.value;
      },
      sourceProperties
    );

    return sourceProperties;
  }
});



// WEBPACK FOOTER //
// ./app/vendor/utility-js-interface/src/preprocessors/key_value_pair.js